"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactAria = require("react-aria");
var _react = _interopRequireDefault(require("react"));
var _reactStately = require("react-stately");
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const TooltipChild = ({
  state,
  ...props
}) => {
  let {
    tooltipProps
  } = (0, _reactAria.useTooltip)(props, state);
  return (0, _jsxRuntime.jsx)("span", {
    css: theme => [_styles.styles.tooltip(theme)],
    ...(0, _reactAria.mergeProps)(props, tooltipProps),
    children: props.children
  });
};
const Tooltip = props => {
  let state = (0, _reactStately.useTooltipTriggerState)(props);
  let ref = _react.default.useRef(null);
  let {
    triggerProps,
    tooltipProps
  } = (0, _reactAria.useTooltipTrigger)(props, state, ref);
  return (0, _jsxRuntime.jsxs)("span", {
    css: () => [_styles.styles.default],
    ref: ref,
    ...triggerProps,
    children: [props.children, state.isOpen && (0, _jsxRuntime.jsx)(TooltipChild, {
      state: state,
      ...tooltipProps,
      children: props.tooltip
    })]
  });
};
var _default = exports.default = Tooltip;